import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import "../assets/css/nav.css";
import Logo from "../assets/svg/Logo4.svg";
import HomeIcon from "../assets/svg/HomeIcon.svg";
import AboutIcon from "../assets/svg/AboutIcon.svg";
import ServicesIcon from "../assets/svg/ServicesIcon.svg";
import PartnersIcon from "../assets/svg/PartnersIcon.svg";
import ResourcesIcon from "../assets/svg/ResourcesIcon.svg";
import ContactIcon from "../assets/svg/ContactIcon.svg";
import NewsIcon from "../assets/svg/news.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const closeMenu = (e) => {
      if (menuOpen && !e.target.closest(".contenedorNavBar")) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, [menuOpen]);

  return (
    <nav className={`contenedorNavBar ${isScrolled ? "scrolled" : ""}`}>
      <div className="mobile-logo">
        <img
          src={Logo}
          alt="Logo T&T"
          className={`Logo3 ${menuOpen ? "active" : ""}`}
        />
        <div
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 51">
            <path
              d="M14.5833 25.5002C14.5833 27.8014 12.7179 29.6668 10.4167 29.6668C8.11548 29.6668 6.25 27.8014 6.25 25.5002C6.25 23.1989 8.11548 21.3335 10.4167 21.3335C12.7179 21.3335 14.5833 23.1989 14.5833 25.5002Z"
              fill="#191718"
            />
            <path
              d="M29.1666 25.5002C29.1666 27.8014 27.3012 29.6668 24.9999 29.6668C22.6987 29.6668 20.8333 27.8014 20.8333 25.5002C20.8333 23.1989 22.6987 21.3335 24.9999 21.3335C27.3012 21.3335 29.1666 23.1989 29.1666 25.5002Z"
              fill="#191718"
            />
            <path
              d="M43.7501 25.5002C43.7501 27.8014 41.8847 29.6668 39.5834 29.6668C37.2822 29.6668 35.4167 27.8014 35.4167 25.5002C35.4167 23.1989 37.2822 21.3335 39.5834 21.3335C41.8847 21.3335 43.7501 23.1989 43.7501 25.5002Z"
              fill="#191718"
            />
          </svg>
        </div>
      </div>

      <div
        className={`nav-overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      <ul className={`contenedorLista ${menuOpen ? "active" : ""}`}>
        <li>
          {menuOpen && isMobile && (
            <img src={HomeIcon} alt="Inicio" className="nav-icon" />
          )}
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Inicio
          </NavLink>
        </li>
        <li className="has-submenu">
          {menuOpen && isMobile && (
            <img src={AboutIcon} alt="Nosotros" className="nav-icon" />
          )}
          <NavLink to="/nosotros" onClick={() => setMenuOpen(false)}>
            Nosotros
          </NavLink>
          {/* Solo renderiza el submenú si NO es móvil */}
          {!isMobile && (
            <ul className="submenu">
              <li>
                <NavLink to="/nosotros" onClick={() => setMenuOpen(false)}>
                  Nosotros
                </NavLink>
              </li>
              <li>
                <NavLink to="/socios" onClick={() => setMenuOpen(false)}>
                  Colaboradores
                </NavLink>
              </li>
            </ul>
          )}
        </li>
        <li className="solo-movil">
          {menuOpen && isMobile && (
            <img src={PartnersIcon} alt="Socios" className="nav-icon" />
          )}
          <NavLink to="/socios" onClick={() => setMenuOpen(false)}>
            Colaboradores
          </NavLink>
        </li>
        <li>
          {menuOpen && isMobile && (
            <img src={ServicesIcon} alt="Servicios" className="nav-icon" />
          )}
          <NavLink to="/servicios" onClick={() => setMenuOpen(false)}>
            Servicios
          </NavLink>
        </li>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img
            src={Logo}
            alt="Logo T&T"
            className={`Logo ${menuOpen ? "active" : ""}`}
            style={{ cursor: "pointer" }}
          />
        </Link>
        <li>
          {menuOpen && isMobile && (
            <img src={ResourcesIcon} alt="Recursos" className="nav-icon" />
          )}
          <NavLink to="/recursos" onClick={() => setMenuOpen(false)}>
            Recursos
          </NavLink>
        </li>
        <li>
          {menuOpen && isMobile && (
            <img src={ContactIcon} alt="Contacto" className="nav-icon" />
          )}
          <NavLink to="/contacto" onClick={() => setMenuOpen(false)}>
            Contacto
          </NavLink>
        </li>
        <li>
          {menuOpen && isMobile && (
            <img src={NewsIcon} alt="Contacto" className="nav-icon" />
          )}
          <NavLink to="/boletin" onClick={() => setMenuOpen(false)}>
            Boletin
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
export default Navbar;
